import { render, staticRenderFns } from "./create-account.vue?vue&type=template&id=298a0a75&scoped=true&"
import script from "./create-account.vue?vue&type=script&lang=ts&"
export * from "./create-account.vue?vue&type=script&lang=ts&"
import style0 from "./create-account.vue?vue&type=style&index=0&id=298a0a75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a0a75",
  null
  
)

export default component.exports